window.addEventListener('pageshow', function(event) {
  const entries = window.performance.getEntriesByType('navigation');

  if (entries[0].type === 'back_forward') {
    const buyButton = document.querySelector('product-form.product-form button[type="submit"]');
    const stickyAtcButton = document.querySelector('sticky-atc .sticky-atc-button__submit');
    const greenhouseInCartMsg = document.querySelector('product-form.product-form[data-greenhouse-product-type] .greenhouse-in-cart-msg');
    const greenhouseType = document.querySelector('product-form.product-form[data-greenhouse-product-type]').getAttribute('data-greenhouse-product-type');

    const cartCountElements = document.querySelectorAll('.cart-count-bubble .cart-count-number');
    const cartCountSeoElements = document.querySelectorAll('.cart-count-bubble .cart-count-number-seo');

    if(buyButton && stickyAtcButton && greenhouseInCartMsg && greenhouseType) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {

          let totalItems = 0;
          data.items.forEach(item => {
            totalItems += item.quantity;
          });

          if(totalItems === 0) {
            buyButton.disabled = false;
            stickyAtcButton.disabled = false;
            greenhouseInCartMsg.style.display = 'none';

            cartCountElements.forEach(element => {
              const countBubble = element.closest('.cart-count-bubble')
              if(countBubble) {
                countBubble.remove();
              }
            });
            return;
          }
          data.items.forEach(item => {
            if (item.product_type === greenhouseType) {
              buyButton.disabled = true;
              stickyAtcButton.disabled = true;
              greenhouseInCartMsg.style.display = 'block';

              cartCountElements.forEach(element => {
                element.innerText = totalItems;
              });

              cartCountSeoElements.forEach(element => {
                element.innerText = `${totalItems} items`;
              });
              return;

            } else {
              buyButton.disabled = false;
              stickyAtcButton.disabled = false;
              greenhouseInCartMsg.style.display = 'none';

              cartCountElements.forEach(element => {
                element.innerText = totalItems;
              });

              cartCountSeoElements.forEach(element => {
                element.innerText = `${totalItems} items`;
              });
            }
          });
        });
    }
  }
});
